import { Contact } from "@interfaces/contact-us"
import KyMethod from "./KyMethod"

interface ContactRequest {
  data: Contact
}

export default class ContactUsRepositories extends KyMethod {
  async rawSubmitContactUs({ data }: ContactRequest) {
    return this._protectedCrudStrapiMethod(`/contact-uses`, {
      body: { data },
    })
  }
}
